import { useEffect, useRef } from "react";
import { useTracker } from "@ferrivia/auth-web";
import { InstallBanner } from "./InstallBanner";
import { IosInstallSheet } from "./IosInstallSheet";
import { installPlatform } from "./installability";
import { useInstallPrompt } from "./useInstallPrompt";

export function InstallPrompt() {
  const tracker = useTracker();
  const { visible, mode, accept, dismiss, instructionsOpen, closeInstructions } = useInstallPrompt();
  const shown = useRef(false);

  useEffect(() => {
    if (visible && !shown.current) {
      shown.current = true;
      tracker.track("app.install_prompt_shown", { platform: installPlatform() });
    }
  }, [visible, tracker]);

  if (!visible) return null;

  async function handleAccept() {
    tracker.track("app.install_accepted", { platform: installPlatform() });
    const outcome = await accept();
    if (mode === "ios") {
      tracker.track("app.install_instructions_shown", {});
    } else if (outcome === "accepted") {
      tracker.track("app.install_completed", { platform: installPlatform() });
    }
  }

  function handleDismiss() {
    tracker.track("app.install_prompt_dismissed", { platform: installPlatform() });
    dismiss();
  }

  return (
    <>
      <InstallBanner onAccept={handleAccept} onDismiss={handleDismiss} />
      {mode === "ios" ? (
        <IosInstallSheet open={instructionsOpen} onOpenChange={(open) => !open && closeInstructions()} />
      ) : null}
    </>
  );
}
